import React, { Component } from 'react'
import { contactSupport } from '../../../support/contactSupport'
import './errorReference.scss'

// The support line under an error: "Reference: CODE · 26 Oct 12:41 · 7f3a9c21", selectable, with a
// copy button (copies the full server id), and optionally "Contact support".
class ErrorReference extends Component {
  state = { copied: false }

  componentWillUnmount() {
    window.clearTimeout(this.copiedTimer)
  }

  copy = () => {
    const { error } = this.props
    const text = `Reference: ${error.fullReference || error.reference}`
    const done = () => {
      this.setState({ copied: true })
      window.clearTimeout(this.copiedTimer)
      this.copiedTimer = window.setTimeout(() => this.setState({ copied: false }), 2000)
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, () => {})
      }
    } catch (e) {
      // The line stays selectable.
    }
  }

  contact = () => {
    const { error, onContactSupport } = this.props
    contactSupport(error)
    if (onContactSupport) onContactSupport()
  }

  render() {
    const { error, showContact, className } = this.props
    if (!error || !error.reference) {
      return null
    }
    const canCopy = typeof navigator !== 'undefined' && !!navigator.clipboard
    return (
      <div className={`lt-error-reference${className ? ` ${className}` : ''}`}>
        <p className="lt-error-reference__line">
          <span className="lt-error-reference__text">Reference: {error.reference}</span>
          {canCopy && (
            <button
              type="button"
              className="lt-error-reference__copy"
              onClick={this.copy}
              aria-label="Copy the support reference"
            >
              {this.state.copied ? 'Copied' : 'Copy'}
            </button>
          )}
        </p>
        {showContact && (
          <button type="button" className="lt-error-reference__contact" onClick={this.contact}>
            Contact support
          </button>
        )}
      </div>
    )
  }
}

export default ErrorReference



// WEBPACK FOOTER //
// ./src/components/UI/ErrorReference/index.js